<form form="ngForm">
    <select [(ngModel)]="tipo" id="tipo-identificacao" name="tipo-identificacao" class="form-control" (change)="onChange()" appShowErrorMessages [required]="required">
      <option value="1">RG</option>
      <option value="2">CARTEIRA DE CLASSE</option>
      <option value="3">CTPS</option>
      <option value="4">CNH</option>
      <option value="5">RNE</option>
    </select>
</form>